import React, { useCallback, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import useSwipe from '../../hooks/useSwipe';
import { useDocReader, useDocReaderDispatch } from '../../store/docReaderContext';

import './index.scss';

interface SwipeProps {
    children: React.ReactNode;
}

const CACHE_SIZE = 2;

const Swipe: React.FC<SwipeProps> = ({ children }) => {
    const [state] = useDocReader();
    const { pageNum } = state;
    const dispatch = useDocReaderDispatch();
    const [visibleRange, setVisibleRange] = useState([0, 1]);
    const swipeRef = useRef<HTMLDivElement | null>(null);

    // 翻页缓存
    const isInCache = useCallback(
        (index: number) => {
            return index >= visibleRange[0] && index <= visibleRange[1];
        },
        [visibleRange],
    );

    // 翻页
    useEffect(() => {
        const childCount = React.Children.count(children);
        setVisibleRange([
            Math.max(pageNum.value - 1 - CACHE_SIZE, 0),
            Math.min(pageNum.value - 1 + CACHE_SIZE, childCount),
        ]);
    }, [pageNum, children]);

    // 滑动时禁用滚动
    const handleSwiping = (direction: string, e: any) => {
        if (direction === 'left' || direction === 'right') {
            e.preventDefault();
        }
    };
    // 滑动翻页交互
    const handleSwipe = (direction: string) => {
        // swipeRef 可以滚动时，不触发翻页
        if (swipeRef.current && swipeRef.current.scrollWidth > swipeRef.current.clientWidth) {
            return;
        }
        if (direction === 'left') {
            dispatch({ type: 'pageNext' });
        } else if (direction === 'right') {
            dispatch({ type: 'pagePrev' });
        }
    };
    useSwipe({
        swipeRef,
        onSwiping: handleSwiping,
        onSwipeEnd: handleSwipe,
    });

    return (
        <div ref={swipeRef} className="swipe">
            {React.Children.map(children, (child, index) => (
                <div
                    key={index}
                    className={classNames({
                        'swipe-item': true,
                        'swipe-item-active': pageNum.value === index + 1,
                        'swipe-item-prev': index + 1 < pageNum.value,
                        'swipe-item-next': index + 1 > pageNum.value,
                    })}
                >
                    {isInCache(index) && child}
                </div>
            ))}
        </div>
    );
};

export default Swipe;
